import { render, staticRenderFns } from "./Die_Part.vue?vue&type=template&id=3e689cfe&scoped=true"
import script from "./Die_Part.vue?vue&type=script&lang=js"
export * from "./Die_Part.vue?vue&type=script&lang=js"
import style0 from "./Die_Part.vue?vue&type=style&index=0&id=3e689cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e689cfe",
  null
  
)

export default component.exports